import { API_BASE_URL } from "../config/apiConfig";

/** API origin without /api suffix — static files live at {origin}/media/... */
export function getApiOrigin() {
  return API_BASE_URL.replace(/\/api\/?$/i, "");
}

/** Normalise stored logo values to /media/logos/... (fixes stale http://localhost:8000/... in DB). */
export function extractOrganisationLogoPath(logoUrl) {
  if (!logoUrl) return null;
  const raw = String(logoUrl).trim();
  const match = raw.match(/\/media\/[^\s?#]+/i);
  if (match) return match[0];
  if (raw.startsWith("/media/")) return raw.split("?")[0];
  return null;
}

/**
 * Absolute URL for <img src> — always targets the API host (e.g. :9000/media/...).
 * Relative /media paths on the CRA dev server (:9999) fail unless the proxy is restarted.
 */
export function getOrganisationLogoUrl(logoUrl, cacheBust) {
  const path = extractOrganisationLogoPath(logoUrl);
  if (!path) return null;

  let url = `${getApiOrigin()}${path}`;
  if (cacheBust != null && cacheBust !== "") {
    url += `${url.includes("?") ? "&" : "?"}v=${encodeURIComponent(cacheBust)}`;
  }
  return url;
}

export const ORG_BRANDING_UPDATED_EVENT = "org-branding-updated";

export function notifyOrganisationBrandingUpdated(detail = {}) {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(ORG_BRANDING_UPDATED_EVENT, { detail }));
  }
}
